import { render, staticRenderFns } from "./big-picture.vue?vue&type=template&id=c82f7c94&scoped=true"
import script from "./big-picture.vue?vue&type=script&lang=js"
export * from "./big-picture.vue?vue&type=script&lang=js"
import style0 from "./big-picture.vue?vue&type=style&index=0&id=c82f7c94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82f7c94",
  null
  
)

export default component.exports